export default __webpack_public_path__ + "static/media/pave.8ae488ee.svg";